const rawBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;

const normalizedBaseUrl = rawBaseUrl
  ? rawBaseUrl.replace(/\/+$/, '')
  : '';

export const apiUrl = (path: string) => {
  if (!path.startsWith('/')) {
    return `${normalizedBaseUrl}/${path}`;
  }
  return `${normalizedBaseUrl}${path}`;
};
